import { authLogger } from './logger';

// Vite replaces import.meta.env.VITE_AUTH_DEBUG at build time. Keep access direct.
export function isClientAuthDebug(): boolean {
  try {
    const v = String(import.meta.env?.VITE_AUTH_DEBUG || '').toLowerCase();
    return v === '1' || v === 'true';
  } catch { return false; }
}

// Emit client auth logs via Pino, gated by VITE_AUTH_DEBUG.
export function clientAuthLog(event: string, data?: unknown): void {
  if (isClientAuthDebug()) {
    authLogger.debug({ event, data }, 'auth-debug');
  }
}


